if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class Header extends HTMLElement {
      constructor() {
        super();
        this.menuOpen = false;
      }
    
      connectedCallback() {
        const setDocumentVariables = () => {
          this.submenu = this.querySelector('[data-submenu-wrapper]');
          this.submenuContentArea = this.querySelector('[data-submenu-content-wrapper]');
          this.navWrapper = this.submenu.closest('site-header');
          this.headerHeight = this.closest('.shopify-section-group-header-group')?.scrollHeight;
        };
        
        if (document.readyState === 'complete') {
          setDocumentVariables();
          this.addDelegatedClickListeners();
        } else {
          document.addEventListener('DOMContentLoaded', () => {
            setDocumentVariables();
            this.addDelegatedClickListeners();
          });
        }
        
        window.addEventListener('resize', () => {
          this.headerHeight = this.closest('.shopify-section-group-header-group')?.scrollHeight;
        });
        
        // window.addEventListener('scroll', () => {
        //   if ((window.scrollY > this.lastScroll) && (window.scrollY > (this.headerHeight * 2))) {
        //     document.body.classList.add('scrolling-down');
        //   } else {
        //     document.body.classList.remove('scrolling-down');
        //   }
          
        //   this.lastScroll = window.scrollY;
        // }, { passive: true });
      }
      
      closeAllMenus() {
        if (!this.menuOpen) return;
          
        this.menuOpen = false;
        this.submenuContentArea.innerHTML = '';
        this.querySelectorAll(`[data-action="open-submenu"][data-menu-id].active`)
          .forEach((submenuToggle) => {
            submenuToggle.classList.remove('active');
          });
        this.querySelectorAll('.slide-in').forEach((x) => x.classList.remove('slide-in'));
        this.classList.remove('slide-in-open');
        document.body.classList.remove('overlay', 'nav-open');

        const gorgias_container = document.querySelector('#gorgias-chat-container');
        if (gorgias_container) gorgias_container.style.zIndex = '31';
        
        // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
        //   needsclick_el.style.zIndex = '31';
        // });
      }
      
      autoOpen(menuId) {
        const actionElement = this.querySelector(`[data-menu-id="${menuId}"]`);
        const template = this.querySelector(`[data-menu-template][data-menu-id="${menuId}"]`);
        if (!template) return;
        
        this.menuOpen = true;
        document.body.classList.add('overlay', 'nav-open');
        actionElement.classList.add('active');
        this.querySelectorAll(`[data-action="open-submenu"]:not([data-menu-id="${menuId}"]).active`)
          .forEach((submenuToggle) => {
            submenuToggle.classList.remove('active');
          });
        this.submenuContentArea.innerHTML = template.innerHTML;
      }
      
      addDelegatedClickListeners() {        
        // this.autoOpen('menu-sections--14593258618951__header-mobile');
        document.addEventListener('click', (e) => {
          if (e.target !== this.submenu && !e.target.closest('[data-submenu-wrapper]') && e.target.dataset.action != 'open-submenu' && window.outerWidth > 1280) {
            this.closeAllMenus();
          }
        });
        
        ['click'].forEach(eventType => {
          this.addEventListener(eventType, (e) => {
            const actionElement = e.target.closest('[data-action]');
            if (!actionElement) return;
            
            const {
              action,
              menuId
            } = actionElement.dataset;
            
            switch (action) {
              case 'close-submenu':
                this.closeAllMenus();
              break;
              case 'open-submenu':
                if (actionElement.classList.contains('active')) {
                  this.closeAllMenus();
                  return;
                }
                
                const template = this.querySelector(`[data-menu-template][data-menu-id="${menuId}"]`);
                if (!template) return;
                                
                this.menuOpen = true;
                document.body.classList.add('overlay', 'nav-open');
                actionElement.classList.add('active');
                this.querySelectorAll(`[data-action="open-submenu"]:not([data-menu-id="${menuId}"]).active`)
                  .forEach((submenuToggle) => {
                    submenuToggle.classList.remove('active');
                  });
                this.submenuContentArea.innerHTML = template.innerHTML;

                const gorgias_container = document.querySelector('#gorgias-chat-container');
                if (gorgias_container) gorgias_container.style.zIndex = '-1';
                
                // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
                //   needsclick_el.style.zIndex = '-1';
                // });
              break;
              case 'open-slide-in':
                const slideInMenu = this.querySelector(`[data-slidein-id="${menuId}"]`);
                slideInMenu.classList.add('slide-in');
                this.querySelectorAll(`[data-slidein-id]:not([data-slidein-id="${menuId}"]).slide-in`)
                  .forEach((otherSlideIn) => {
                    otherSlideIn.classList.remove('slide-in');
                  });
                this.classList.add('slide-in-open');
              break;
              case 'close-slide-in':
                this.querySelectorAll('.slide-in').forEach((x) => x.classList.remove('slide-in'));
                this.classList.remove('slide-in-open');
              break;
              default: break;
            }
          });
        });
      }
    }
  )
}